// Helper para unificar la petición de perfiles de media ONVIF
// Acepta tanto { connection: {...} } como directamente el objeto de conexión
// Permite enviar extras opcionales (por ejemplo, { rtsp: 'rtsp://...' }) si el backend los soporta
// Devuelve la respuesta de Axios sin modificarla, preservando el comportamiento actual
export async function fetchOnvifMediaProfiles(axiosInstance, baseURL, connectionLike, extras = undefined) {
	const rawConnection = connectionLike && connectionLike.connection ? connectionLike.connection : connectionLike;
	if (!rawConnection) {
		throw new Error('Missing ONVIF connection parameters');
	}
	// Normalizar payload
	const payload = { connection: {} };
	if (rawConnection.xaddr) {
		payload.connection = {
			xaddr    : rawConnection.xaddr,
			username : rawConnection.username,
			password : rawConnection.password,
		};
		// Si también viene hostname, incluirlo
		if (rawConnection.hostname || rawConnection.host) {
			payload.connection.hostname = rawConnection.hostname || rawConnection.host;
		}
	} else {
		payload.connection = {
			hostname : rawConnection.hostname || rawConnection.host,
			port     : rawConnection.port,
			secure   : rawConnection.secure,
			username : rawConnection.username,
			password : rawConnection.password,
		};
	}
	// Agregar campos RTSP si vienen en rawConnection (tanto con xaddr como sin xaddr)
	if (rawConnection.rtsp) {
		payload.connection.rtsp = rawConnection.rtsp;
	}
	if (rawConnection.rtsp1) {
		payload.connection.rtsp1 = rawConnection.rtsp1;
	}
	if (rawConnection.rtsp2) {
		payload.connection.rtsp2 = rawConnection.rtsp2;
	}
	
	if (extras && typeof extras === 'object') {
		// Si hay rtsp, rtsp1 o rtsp2 en extras, agregarlos dentro de connection
		if (extras.rtsp) {
			payload.connection.rtsp = extras.rtsp;
		}
		if (extras.rtsp1) {
			payload.connection.rtsp1 = extras.rtsp1;
		}
		if (extras.rtsp2) {
			payload.connection.rtsp2 = extras.rtsp2;
		}
		// Otros campos extras van al nivel superior del payload
		const otherExtras = { ...extras };
		delete otherExtras.rtsp;
		delete otherExtras.rtsp1;
		delete otherExtras.rtsp2;
		if (Object.keys(otherExtras).length > 0) {
			Object.assign(payload, otherExtras);
		}
	}
	return await axiosInstance.post(baseURL + '/api/v1/onvif/media/profiles', payload);
}


